export default __webpack_public_path__ + "static/media/Icon5.85fc11fa.png";